<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="厂区">
              <a-input placeholder="请输入厂区" v-model="queryParam.factoryName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="区域编码">
              <a-input placeholder="请输入区域编码" v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="区域名称">
              <a-input placeholder="请输入区域名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" v-has="'preArea:search'" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" v-has="'preArea:reset'" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" v-has="'preArea:add'" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('pre_area')">导出</a-button> -->
      <!-- 高级查询区域 -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <template slot="status" slot-scope="text, record">
          <j-switch v-model="record.status" @change="statusChange(record)"  ></j-switch>
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-has="'preArea:edit'" @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'preArea:detail'">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-has="'preArea:delete'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <pre-area-modal ref="modalForm" @ok="modalFormOk"></pre-area-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import PreAreaModal from './modules/PreAreaModal'
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'PreAreaList',
    mixins:[JeecgListMixin, mixinDevice,JEditableTableModelMixin],
    components: {
      PreAreaModal
    },
    data () {
      return {
        description: 'pre_area管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'省份',
            align:"center",
            dataIndex: 'provinceName'
          },
          {
            title:'城市',
            align:"center",
            dataIndex: 'cityName'
          },
          {
            title:'厂区',
            align:"center",
            dataIndex: 'factoryName'
          },
          {
            title:'区域编码',
            align:"center",
            dataIndex: 'code'
          },
          {
            title:'区域名称',
            align:"center",
            dataIndex: 'name'
          },
          /* {
            title:'是否启用',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'status'}
          }, */
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        model:{},
        url: {
          list: "/prevent/area/preareas",
          delete: "/prevent/area/preareaDeleteById",
          deleteBatch: "/prevent/area/prearea/batchDelete",
          exportXlsUrl: "/prevent/area/export-xls",
          importExcelUrl: "prevent/area/import-excel",
          edit: "/prevent/area/preareaEdit",          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      statusChange(record)
      {
        this.model = Object.assign({}, record); 
        httpAction(this.url.edit,this.model,'put').then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
